import { Outlet, useLocation, useNavigate, useRouteError } from "react-router-dom";
import Header from "./Header";
import { Hidden, Typography } from "@mui/material";
import ButtomNavigation from "./ButtomNavigation";
import { useContext, useEffect } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import localeData from "dayjs/plugin/localeData";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fa";
import axios from "axios";
import IResponse from "../../interfaces/response";
import ProfileType from "../../interfaces/profile";
import { ProfileContext } from "../../ProfileContext";
import 'react-photo-view/dist/react-photo-view.css';
import { useTranslation } from "react-i18next";

interface IProps {
	children?: React.ReactNode;
}

export default function App({ children }: IProps) {
	dayjs.extend(duration);
	dayjs.extend(localeData);
	dayjs.extend(relativeTime);
	const location = useLocation();
	const navigate = useNavigate();
	const { profile, setProfile } = useContext(ProfileContext);
	const { t } = useTranslation();
	const blocked = !!profile?.is_expired && location.pathname !== '/profile';

	useEffect(() => {
		if (!localStorage.getItem("token")) {
			navigate('/auth/login');
		} else {
			axios<IResponse<ProfileType>>({
				url: '/user',
			}).then(res => {
				if (res.data.success) {
					localStorage.setItem('profile', JSON.stringify(res.data.data));
					setProfile(res.data.data);
				}
			});
		}
	}, [navigate, setProfile]);

	return (
		<div className="flex flex-col h-full md:container md:mx-auto">
			{
				location.pathname === "/" &&
				<>
					<div className="absolute top-0 left-0 -z-10 w-full h-full bg-text-primary/70" />
					<video className="absolute top-0 left-0 -z-20 w-full h-full object-cover" autoPlay muted loop playsInline>
						<source src='/background.mp4' type='video/mp4'></source>
					</video>
				</>
			}
			<Header />
			<div className="grow basis-0 px-4 md:px-0 py-10 overflow-y-auto overflow-x-hidden md:py-14">
				{
					blocked
						? <Typography className="text-center text-error-main font-bold">{t('expiry_expired_message')}</Typography>
						: children ?? <Outlet />
				}
			</div>
			<Hidden smUp>
				<ButtomNavigation />
			</Hidden>
		</div>
	);
}

export function AppErrorElement() {
	const error = useRouteError();
	const { t } = useTranslation();
	// @ts-expect-error missing status property on route error type
	const code = error.status ?? "600";

	return (
		<div className="mx-auto w-fit flex flex-col text-center">
			<Typography>{t('error', { code })}</Typography>
			<img src="/error.png" className="max-w-md" alt="error" />
		</div>
	);
}